import React from "react";
import { Check } from "lucide-react";

export const Timeline = ({ steps }) => (
  <div className="relative pl-8">
    <div className="absolute left-3 top-2 bottom-2 w-px" style={{ background: "linear-gradient(180deg,#1E1E22,#27272A,#1E1E22)" }}/>
    <ol className="space-y-6">
      {steps.map((s, i) => {
        const done = s.status === "done";
        const active = s.status === "active";
        return (
          <li key={s.id} className="relative">
            <div className="absolute -left-8 top-0.5 flex items-center justify-center w-6 h-6 rounded-full"
                 style={{
                   background: done ? "#10B981" : active ? "rgba(59,130,246,0.15)" : "#111114",
                   border: `1px solid ${done ? "#10B981" : active ? "#3B82F6" : "#27272A"}`,
                   boxShadow: active ? "0 0 0 4px rgba(59,130,246,0.15)" : "none",
                 }}>
              {done ? <Check size={12} className="text-black"/> : <span className={`text-[10px] font-mono ${active ? "text-blue-400" : "text-zinc-500"}`}>{i + 1}</span>}
            </div>
            <div className="pb-1">
              <div className={`text-sm ${done ? "text-zinc-300" : active ? "text-white font-medium" : "text-zinc-500"}`}>{s.label}</div>
              <div className="text-xs text-zinc-500 mt-0.5 font-mono">{s.ts}</div>
            </div>
          </li>
        );
      })}
    </ol>
  </div>
);

export default Timeline;
